import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	COL_REVERSE: '[data-fragment="Awards.colReverse"]',
	SHOW_MORE_PRICE: '[data-fragment="Awards.showMorePrice"]',
	SHOW_MORE_ROWS_IN_BLOCK: '[data-fragment="Awards.showMoreRowsInBlock"]',
	YEAR_CONTENT: '[data-fragment="Awards.yearContent"]',
};

class Awards extends WebComponent {
	constructor(props) {
		super(props);
	}
	didMount() {
		const {
			hideClass,
		} = this.props;

		this.hideClass = hideClass;

		this.awardsYearBlockReverse = this.element.querySelectorAll('.awards-year__block--reverse');

		// this.yearContentElement = this.element.querySelector(fragments.YEAR_CONTENT);

		this.colReverse = this.element.querySelector(fragments.COL_REVERSE);

		// this.showItem = parseInt(this.yearContentElement.getAttribute('data-show-item'));

		this.on('click', fragments.SHOW_MORE_PRICE, this.handleClickOnShowMorePrice)
		this.on('click', fragments.SHOW_MORE_ROWS_IN_BLOCK, this.handleClickOnShowMoreRowsInBlock);
		this.initCol();
		window.addEventListener('resize', this.initCol);
	}

	initCol = () => {
		for(let i = 0; i < this.awardsYearBlockReverse.length; i++) {
			if (window.innerWidth > 1052) {
				this.colReverse.appendChild(this.awardsYearBlockReverse[i]);
			} else {
				let colId = parseInt(this.awardsYearBlockReverse[i].getAttribute('data-col-id'))-1;
				let previousCol = this.element.querySelector('.awards-year__block[data-col-id="'+colId+'"]');
				this.insertAfter(this.awardsYearBlockReverse[i],previousCol);
			}
		}
	}

	handleClickOnShowMorePrice = (e) => {
		e.preventDefault();
		let awardsYearFirstBlockHide = this.element.querySelector(this.hideClass);
		if(awardsYearFirstBlockHide) {
			let colId = parseInt(awardsYearFirstBlockHide.getAttribute('data-col-id'));
			for(let i = 0; i < this.showItem; i++) {
				let awardsYearBlockHide = this.element.querySelector('.awards-year__block[data-col-id="'+colId+'"]')
				if(awardsYearBlockHide) {
					awardsYearBlockHide.classList.remove(this.hideClass.substring(1));
				}
				colId++;
			}
		}
		if(this.element.querySelectorAll(this.hideClass).length === 0) {
			e.target.style.display = 'none';
		}
	}

	handleClickOnShowMoreRowsInBlock = (e) => {
		e.preventDefault();

		let parentElement = e.target.parentElement.offsetParent;
		console.log(parentElement);
		let hideElements = parentElement.querySelectorAll('.hide');

		for(let i = 0; i < hideElements.length; i++) {
			hideElements[i].classList.remove('hide');
		}

		e.target.style.display = 'none';
	}

	insertAfter = (newNode, existingNode) => {
		existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
	}
}

Awards.defaultProps = {
	hideClass: '.awards-year__block--hide',
};

export default Awards;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Awards.js